import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipGrid } from '@angular/material/chips';
import { Lookup } from '../../models/lookup';

@Component({
  selector: 'app-tree-field-radio',
  templateUrl: './tree-field-radio.component.html',
  standalone: false
})
export class TreeFieldRadioComponent {
  @Input() required = false;
  @Input() isSubmitted = false;
  @Input() recordsLoading = false;
  @Input() isDisabled = false;
  @Input() recordsTree: any[] = [];
  @Input() labelField: string = '';
  @Input() key!: string;
  @Input() detailsSelectedRecords: any;
  @Output() selected = new EventEmitter();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  addOnBlur = false;
  selectable = true;
  removable = true;
  searchCtrl = new FormControl();
  selectedRecords: Lookup[] = [];
  selectedRecordsTree: Lookup[] = [];
  showRecordsTree = false;
  removeItem!: any;

  // recordsLoading = false;
  @ViewChild('chipRecordsList', { static: false }) chipRecordsList!: MatChipGrid;
  @ViewChild('searchInput', { static: false }) searchInput!: ElementRef<HTMLInputElement>;

  constructor(private eRef: ElementRef) { }

  updateSelectedRecords(data: any) {
    this.detailsSelectedRecords = [];
    this.selectedRecords = [];
    if (data) {
      if (data && data instanceof Array) {
        data.forEach((element: Lookup) => {
          if (!element.child && !this.isInArray(this.selectedRecords, element)) {
            this.selectedRecords.push(element);
          }
        });
      } else {
        this.selectedRecords.push(data);
      }
      this.selected.emit(data && data instanceof Array ? this.selectedRecords : data);
      this.showRecordsTree = false;
    }
  }

  isInArray(parentObj: any, item: any) {
    return parentObj.some((obj: any) => obj.id === item.id);
  }

  // dropdowns overlay events
  @HostListener('window:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.showRecordsTree = false;
    }
  }
  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!event) {
      this.showRecordsTree = !this.showRecordsTree;
    } else if (!this.eRef.nativeElement.contains(event.target)) {
      this.showRecordsTree = false;
    }
    if (!this.showRecordsTree) {
      this.searchCtrl.setValue(null);
      this.filterTree('');
    } else {
      this.searchInput?.nativeElement?.focus();
    }
  }

  filterTree(value: string, event = false) {
    if (event) { this.showRecordsTree = true; }
  }

  removeRecord(node: any) {
    this.removeItem = node
    setTimeout(() => {
      this.removeItem = null
    }, 100);
  }

}
